<template>
  <div class="columns">
    <div class="column">
      <b-field
        :label="$t('compCarbonFormsRactivitiesComponentsAstroInput.label-1')"
        :type="{ 'is-danger': errors.has('laboratory') }"
        :message="errors.first('laboratory')"
      >
        <b-autocomplete
          :disabled="disabled"
          expanded
          name="laboratory"
          v-model="laboratory.affiliation"
          :placeholder="
            $t('compCarbonFormsRactivitiesComponentsAstroInput.label-1')
          "
          :data="filteredAffiliations"
          field="affiliation"
          v-validate="'astroActivityAvailable|required|hasAstroActivity'"
          @select="(option) => getAlphas(option)"
          open-on-focus
          append-to-body
          clearable
          data-testid="ractivities-entity-name"
        >
          <template slot-scope="props">
            <div class="media">
              <div class="media-left">
                <flag :iso="getISO(props.option.country)" />
              </div>
              <div class="media-content">
                <strong>{{ props.option.acronym }}</strong>
                <br />
                {{ props.option.affiliation }}
              </div>
            </div>
          </template>
        </b-autocomplete>
      </b-field>
    </div>
  </div>
</template>

<script>
import { useGHGIStore } from '@/stores/ghgi.js'
import { useCoreStore } from '@/stores/core.js'
import AFFILIATIONS from '@/../data/researchActivities/astroAffiliations.json'
import ISO3166 from '@/../data/utils/ISO3166.json'
import { AstroFacilities } from '@/models/carbon/ResearchActivity.js'
import carbonService from '@/services/carbonService'

export default {
  name: 'Input',
  props: {
    ractivity: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ['$validator'],
  data () {
    return {
      laboratory: {
        affiliation: '',
        acronym: '',
        affID: '',
        country: ''
      },
      availableYears: [],
      selectedLab: null,
      activitySet: []
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    const coreStore = useCoreStore()
    return { ghgiStore, coreStore }
  },
  computed: {
    year: function () {
      return parseInt(this.ghgiStore.item.year)
    },
    allowedCountries: function () {
      const iso = this.coreStore.setting('global', 'ALLOWED_COUNTRIES').value
      let countries = ISO3166.filter((option) => iso.indexOf(option.iso) >= 0)
      return countries.flatMap((obj) => obj.names)
    },
    allowedAffiliations: function () {
      return AFFILIATIONS.filter((option) => {
        return this.allowedCountries.indexOf(option.country) >= 0
      })
    },
    filteredAffiliations: function () {
      if (this.availableYears.includes(this.year)) {
        return this.allowedAffiliations.filter((option) => {
          return (
            option.affiliation
              .concat(' ', option.acronym)
              .toString()
              .toLowerCase()
              .indexOf(this.laboratory.affiliation.toLowerCase()) >= 0
          )
        })
      } else {
        return []
      }
    }
  },
  methods: {
    getISO: function (country) {
      if (country) {
        return ISO3166.filter((option) =>
          option.names.some(
            (name) => name.toLowerCase() === country.toLowerCase()
          )
        )[0].iso
      }
    },
    getAlphas: function (option) {
      this.ractivity.items = []
      let self = this
      if (option) {
        this.laboratory = Object.assign({}, option)
        carbonService
          .getAstroAlphas({
            labID: option.affID,
            year: this.year
          })
          .then((data) => {
            if (data) {
              Object.keys(data).forEach(function (inst) {
                if (parseFloat(data[inst]) !== 0) {
                  let activity = new AstroFacilities({
                    category: self.ractivity.category,
                    type: self.ractivity.type,
                    subtype: inst,
                    amount: parseFloat(data[inst])
                  })
                  self.ractivity.items.push(activity)
                }
              })
            }
          })
          .catch((error) => {
            throw error
          })
      }
    }
  },
  created () {
    let self = this
    this.$validator.extend('hasAstroActivity', {
      getMessage: (field) =>
        self.$t('compCarbonFormsRactivitiesComponentsAstroInput.error-1'),
      validate: (value, args) => {
        let searchedLab = self.allowedAffiliations.filter(
          (obj) => obj.affiliation === value
        )
        if (searchedLab.length === 1) {
          return carbonService
            .getAstroAlphas({
              labID: searchedLab[0].affID,
              year: self.year
            })
            .then((data) => {
              let isValid = false
              if (data) {
                isValid = true
              }
              return {
                valid: isValid
              }
            })
        } else {
          return true
        }
      }
    })
    this.$validator.extend('astroActivityAvailable', {
      getMessage: (field) =>
        self.$t('compCarbonFormsRactivitiesComponentsAstroInput.error-2'),
      validate: (value, args) => {
        return this.availableYears.includes(this.year)
      }
    })
  },
  mounted () {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    carbonService
      .getAstroYears()
      .then((years) => {
        this.availableYears = years
        if (!this.availableYears.includes(this.year)) {
          this.$validator.validateAll()
        }
        loadingComponent.close()
      })
      .catch((error) => {
        loadingComponent.close()
        throw error
      })
  }
}
</script>
